var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldDocumentSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    width: 18,
    height: 21.019,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2a2 2 0 012-2h6.172a2 2 0 011.414.586l5.828 5.828A2 2 0 0118 7.828V18a2 2 0 01-2 2h-4.018a1.74 1.74 0 00-.495-.987l-.512-.513H16a.5.5 0 00.5-.5V8H12a2 2 0 01-2-2V1.5H4a.5.5 0 00-.5.5v7.09A5.5 5.5 0 002 9.6V2zm10 4.5h3.38L11.5 2.62V6a.5.5 0 00.5.5zM4.5 19a4.5 4.5 0 002.607-.832L9.72 20.78a.75.75 0 101.06-1.06l-2.612-2.613A4.5 4.5 0 104.5 19zm0-1.5a3 3 0 110-6 3 3 0 010 6z",
    fill: "#000"
  })));
}
export default SvgPldDocumentSearch;